<template>
  <v-row>
    <v-col
      v-for="(item, k) in img"
      :key="k"
      class="d-flex child-flex"
      cols="12"
      sm="4"
      md="3"
    >
      <v-hover v-slot:default="{ hover }">
        <v-card flat tile class="d-flex" :elevation="hover?10:0" style="cursor: pointer; transition: .5s;" @click="openGallery(k)">
          <v-img
            :src="item.link"
            :lazy-src="item.link"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card>
      </v-hover>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    img: {
      type: Array,
      required: true
    }
  },

  methods: {
    ...mapActions({
      openGallery: 'openGallery'
    })
  }
};
</script>

<style></style>
